import React, { useRef, useCallback } from "react";
import { List } from "../../Components/common/List/List";
import { useAppContext } from "../../AppProvider";
import { useBarcodeMovementsProps } from "./utilities/barcodeMovements";
import { useTypes } from "../../utilities/types";
import { getBadge } from "../../Components/Badges/utilities";
import { OrderEvent } from "../../Models/OrderEvent";
import moment from "moment";
import { useBarcodeMovementsContext } from "./providers/BarcodeMovements";
import { BarcodeMovement } from "../../Models/BarcodeMovement";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "../../utilities/fontawesomeIcons";
import { Link } from "react-router-dom";

const AnyList = List as any;

export const BarcodeMovements: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const listProps = useBarcodeMovementsProps();
  const { data, loader } = useBarcodeMovementsContext();

  const renderHeader = () => {
    const { dictionary } = useAppContext();

    return (
      <>
        {data[0] && (
          <div className="d-grid grid-column justify-content-between mb-2">
            <label className="label-3">
              {`${data[0].barcode} - ${data[0].articleName}`}
            </label>
            <Link
              to={`/articles/details/${data[0].articleId}`}
              target="_blank"
              className="span-1"
            >
              {dictionary.actions.view}{" "}
              {dictionary.products.product.toLowerCase()}
            </Link>
          </div>
        )}
        <div className="list-item px-2 border my-1">
          <div
            className="d-grid grid-column align-items-center"
            style={{
              gridTemplateColumns: "0.5fr 0.5fr 1fr 1fr",
            }}
          >
            <label className="label-2">{dictionary.words.status}</label>
            <label className="label-2">{dictionary.dates.creation_date}</label>
            <label className="label-2">{dictionary.registries.departure}</label>
            <label className="label-2">{dictionary.registries.arrival}</label>
          </div>
        </div>
      </>
    );
  };

  const renderItem = useCallback((item: BarcodeMovement) => {
    return <ListItem item={item} />;
  }, []);

  return loader ? (
    <div className="text-center my-2">
      <FontAwesomeIcon icon={faLoader} spin size="2x" />
    </div>
  ) : (
    <AnyList
      ref={listRef}
      title={listProps.title}
      renderHeader={renderHeader}
      renderItem={renderItem}
      pagination={listProps.pagination}
      selectRowsEnabled={listProps.selectRowsEnabled}
      actionBar={listProps.actionBar}
      data={data}
    />
  );
};

export default BarcodeMovements;

const ListItem: React.FC<{ item: BarcodeMovement }> = React.memo(({ item }) => {
  const { barcodeMovements } = useTypes();

  const type = barcodeMovements.find((t) => t.value === item.movementType);
  return (
    <div className="list-item px-2 border my-1">
      <div
        className="d-grid grid-column align-items-center"
        style={{
          gridTemplateColumns: "0.5fr 0.5fr 1fr 1fr",
        }}
      >
        <div>{getBadge({ bgColor: type?.color, text: type?.label })}</div>
        <label className="label-3">
          {item.operationDate
            ? moment(item.operationDate).format("DD/MM/YYYY HH:mm:ss")
            : "-"}
        </label>
        <label className="label-3">{item.pickupName || "-"}</label>
        <label className="label-3">{item.deliveryName || "-"}</label>
      </div>
    </div>
  );
});
